const CURRENCY_LOCALES = {
  CZK: 'cs-CZ',
  PLN: 'pl-PL',
  EUR: 'de-DE',
  USD: 'en-US',
};

export function formatCurrency(amount, options = {}, locale) {
  if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
    const currency = options.currency || 'CZK';
    const resolvedLocale = locale || CURRENCY_LOCALES[currency] || 'cs-CZ';

    const formatOptions = {
      style: 'currency',
      currency,
      ...options,
    };

    return new Intl.NumberFormat(resolvedLocale, formatOptions).format(amount);
  }

  // Fallback pro staré prohlížeče
  return amount.toFixed(2) + ' ' + (options.currency || 'CZK');
}
